import { SENTRY_ENABLED } from '@/config';
import ResponseError from '@/errors/responseError';
import { showDailyLimit } from '@/pages/MyDocuments/DailyLimitModal/utils';

export async function sendErrorToSentry(error) {
	if (!SENTRY_ENABLED) {
		return;
	}

	try {
		const { initSentry } = await import('@/utils/sentry');
		const Sentry = initSentry();
		const context = {};

		if (error instanceof ResponseError) {
			context.extra = {
				status: error.status,
				body: error.data,
				url: error.response?.url,
				method: error.method
			};
		}

		if (typeof error.details === 'object') {
			context.extra = {
				...context.extra,
				...error.details
			};
		}

		Sentry.captureException(error, context);
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error(err);
	}
}

export function showError(error, options) {
	if (error?.data?.errorCode === 'transaction_limit_exceeded') {
		return showDailyLimit();
	}

	let message = '';
	let messageKey = '';

	if (typeof error === 'string') {
		message = error;
	}

	if (import.meta.env.DEV && error instanceof Error) {
		// eslint-disable-next-line no-console
		console.error(error);
	}

	if (error?.status === 401) {
		return;
	}

	if (error?.status === 403) {
		messageKey = 'errors.forbidden';
	}

	if (error?.status === 429) {
		messageKey = 'errors.tooManyRequests';
	}

	if (
		options?.report ??
		(error?.status !== 429 &&
			!message &&
			!messageKey &&
			!options?.message &&
			!options?.messageKey)
	) {
		sendErrorToSentry(error);
	}

	const event = new CustomEvent('showToast', {
		detail: {
			message,
			messageKey: message ? '' : messageKey || 'errors.generic',
			uuid: error?.data?.uuid,
			variant: 'error',
			...options
		}
	});

	window.dispatchEvent(event);
}

export function showEditorError(error, options) {
	let message = '';

	const messageKey = 'errors.generic';

	if (typeof error === 'string') {
		message = error;
	}

	const event = new CustomEvent('showEditorToast', {
		detail: {
			message,
			messageKey: message ? '' : messageKey,
			variant: 'error',
			...options
		}
	});

	window.dispatchEvent(event);
}

export function showSuccess(message, options) {
	const event = new CustomEvent('showToast', {
		detail: {
			message,
			variant: 'success',
			...options
		}
	});

	window.dispatchEvent(event);
}
